import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, X } from "lucide-react";
import { Button } from "components/ui";

// Shown across Control Centre when content screening has something for the
// signed-in admin: items waiting for review, or anything blocked recently.
// Dismissed for the session, until the counts change.
const DISMISS_KEY = "cc-safety-notice-dismissed";

const readDismissed = () => {
  try {
    return sessionStorage.getItem(DISMISS_KEY);
  } catch (e) {
    return null;
  }
};

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

const SafetyNotice = ({ summary }) => {
  const [dismissed, setDismissed] = useState(readDismissed);
  if (!summary?.enabled) return null;

  const { review = 0, blocked = 0, removed = 0, days = 7 } = summary;
  if (!review && !blocked) return null;

  const key = `${review}:${blocked}:${removed}`;
  if (dismissed === key) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, key);
    } catch (e) {
      // Private mode: it just shows again next page load.
    }
    setDismissed(key);
  };

  const parts = [];
  if (review) parts.push(`${plural(review, "item needs", "items need")} reviewing`);
  if (blocked) parts.push(`${plural(blocked, "item was", "items were")} blocked in the last ${days} days`);
  if (removed) parts.push(`${removed} removed`);

  return (
    <div className={`cc-banner cc-safety-notice${review ? " cc-banner--warn" : " cc-banner--info"}`} role="status">
      <ShieldAlert size={20} aria-hidden="true" />
      <div className="cc-safety-notice__body">
        <p className="cc-banner__title">Content safety</p>
        <p className="cc-banner__text">
          {parts.join(" · ")}.{" "}
          <Link to={review ? "/content-review" : "/content-review?tab=blocked"} className="cc-text-link">
            {review ? "Review now" : "View"}
          </Link>
        </p>
      </div>
      <Button variant="ghost" size="sm" iconOnly icon={X} onClick={dismiss} aria-label="Dismiss" />
    </div>
  );
};

export default SafetyNotice;
